import React from 'react';
import styled from 'styled-components'
import { Container, Grid, Header, List } from 'semantic-ui-react'

const Styles = styled.div`
    .footer-main {
        background: var(--color-primary);
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        padding: 4rem 0 2rem;
    }

    .footer-header {
        font-family: 'Sora', sans-serif !important;
        font-size: 1.1rem !important;
        font-weight: 700 !important;
        color: var(--color-text) !important;
        margin-bottom: 1rem !important;
        letter-spacing: 0.02em;
    }

    .footer-list {
        font-family: 'IBM Plex Sans', sans-serif !important;
    }

    .footer-list a {
        color: var(--color-text-muted) !important;
        transition: color 0.3s ease !important;
    }

    .footer-list a:hover {
        color: var(--color-accent) !important;
    }

    .footer-text {
        font-family: 'IBM Plex Sans', sans-serif;
        color: var(--color-text-muted);
        line-height: 1.8;
    }

    .footer-text a {
        color: var(--color-accent);
        text-decoration: none;
        transition: color 0.3s ease;
    }

    .footer-text a:hover {
        color: #66E5FF;
    }

    .footer-bottom {
        text-align: center;
        padding-top: 2rem;
        margin-top: 2rem;
        border-top: 1px solid rgba(255, 255, 255, 0.05);
        font-family: 'IBM Plex Sans', sans-serif;
        color: var(--color-text-muted);
        font-size: 0.9rem;
    }
`

function Footer() {
    return (
        <Styles>
            <div className="footer-main">
                <Container>
                    <Grid divided stackable>
                        <Grid.Row>
                            <Grid.Column width={5}>
                                <Header className="footer-header" content='Products' />
                                <List link className="footer-list">
                                    <List.Item as='a' href='https://pokeswift.com' target='_blank' rel='noopener noreferrer'>
                                        PokeSwift
                                    </List.Item>
                                    <List.Item as='a' href='https://socialbellow.com' target='_blank' rel='noopener noreferrer'>
                                        SocialBellow
                                    </List.Item>
                                </List>
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Header className="footer-header" content='Company' />
                                <List link className="footer-list">
                                    <List.Item as='a' href='/about'>About</List.Item>
                                    <List.Item as='a' href='/contact'>Contact</List.Item>
                                </List>
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <Header className="footer-header" content='Contact' />
                                <div className="footer-text">
                                    Yay Fun, Inc.<br />
                                    3616 Far West Blvd 117-414<br />
                                    Austin, TX 78731<br />
                                    <a href="tel:5127295122">(512) 729-5122</a>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <div className="footer-bottom">
                        © {new Date().getFullYear()} Yay Fun, Inc. All rights reserved.
                    </div>
                </Container>
            </div>
        </Styles>
    )
}

export default Footer
